import { actionTypes } from 'actions/actionTypes'
import { feLoggingLogEvent, logLevels } from 'actions/log'
import { fetchReference } from 'apis/customers'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const fetchGoustoRef: CheckoutActionCreator = () => async (dispatch, getState) => {
  let goustoRef = getState().checkout.get('goustoRef')
  if (!goustoRef) {
    const { data } = await fetchReference()
    goustoRef = data.goustoRef

    dispatch({
      type: actionTypes.CHECKOUT_SET_GOUSTO_REF,
      goustoRef,
    })
    dispatch(feLoggingLogEvent(logLevels.info, 'fetchGoustoRef: fetched'))
  } else {
    dispatch(feLoggingLogEvent(logLevels.info, 'fetchGoustoRef: already present'))
  }
}
